import { IBaseFieldData } from '~/components/MultiGrid/types';
import Pill from '~/components/Pill';
import Text from '~/components/Text';
import { formatDate } from '~/utils/datetime';
import { TEMPLATE_MAPPER } from '../constants';
import { useEmailListContext } from '../hooks/useEmailListContext';

interface ICellContentProps {
  fieldData: IBaseFieldData;
  rowIndex: number;
}

const CellContent = ({ fieldData, rowIndex }: ICellContentProps) => {
  const { listIds, listData } = useEmailListContext();
  const emailUuid = listIds[rowIndex - 1];
  const email = listData[emailUuid];

  if (!email) {
    return null;
  }

  const renderCellContent = () => {
    switch (fieldData.value) {
      case 'recipient_name':
        return <Text className="bold">{email.recipient_name || '-'}</Text>;

      case 'recipient_email':
        return <Text>{email.recipient_email}</Text>;

      case 'subject':
        return <Text>{email.subject}</Text>;

      case 'template_id':
        return <Text>{TEMPLATE_MAPPER[email.template_id] || email.template_id}</Text>;

      case 'status':
        const statusColor =
          email.status === 'sent'
            ? 'success'
            : email.status === 'failed'
              ? 'danger'
              : email.status === 'opened'
                ? 'primary'
                : 'secondary';
        return (
          <Pill className="uppercase" variant={statusColor} size="sm">
            {email.status}
          </Pill>
        );

      case 'sent_at':
        return <Text>{email.sent_at ? formatDate(email.sent_at) : '-'}</Text>;

      default:
        return <Text>-</Text>;
    }
  };

  return <>{renderCellContent()}</>;
};

export default CellContent;
